<template>
  <Page type="no-header">
      <List />
  </Page>
</template>

<script>
import Page from '@/components/visual/Page'
import List from '@/components/dayprediction/List'
// import { mapState, mapGetters } from 'vuex'

export default {
    components: { Page, List },
}
</script>

<i18n locale="ru" lang="yaml">
  pageTitle: "Личный кабинет"
</i18n>

<i18n locale="en" lang="yaml">
  pageTitle: "Dashboard"
</i18n>
